import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
import { CountdownTimer } from './ui/CountdownTimer';
export const FinalCTA: React.FC = () => {
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'elite'>('elite');
  const checkoutUrls = {
    standard: 'https://pagos.recursosfitness.shop/cart/44010877517921:1',
    elite: 'https://pagos.recursosfitness.shop/cart/44010876436577:1'
  };
  return <section className="py-10 md:py-20 bg-primary-dark relative overflow-hidden" data-id="element-106">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-107">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-primary/20 blur-[100px] rounded-full" data-id="element-108"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-109">
        <CountdownTimer data-id="element-110" />

        <div className="text-center mb-8 md:mb-12 mt-8 md:mt-12" data-id="element-111">
          <h2 className="text-3xl md:text-5xl font-bold font-serif text-white mb-3" data-id="element-112">
            Elegí tu{' '}
            <span className="text-accent" data-id="element-113">Profes de Telas Resuelto</span>:
          </h2>
          <p className="text-base md:text-lg text-white/60 font-medium" data-id="element-114">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <div className="flex flex-col gap-4 md:gap-6 mb-8" data-id="element-115">
          {/* Standard Plan */}
          <div onClick={() => setSelectedPlan('standard')} className={`relative rounded-2xl p-4 md:p-6 cursor-pointer transition-all duration-300 border-2 ${selectedPlan === 'standard' ? 'border-white/40 bg-primary shadow-lg' : 'border-white/10 bg-primary/80 hover:bg-primary'}`} data-id="element-116">
            <div className="flex items-center gap-3 md:gap-4" data-id="element-117">
              <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selectedPlan === 'standard' ? 'border-white' : 'border-white/30'}`} data-id="element-118">
                {selectedPlan === 'standard' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 bg-white rounded-full" data-id="element-119" />}
              </div>

              <div className="flex-grow" data-id="element-120">
                <div className="flex items-center gap-2 mb-1" data-id="element-121">
                  <span className="text-lg md:text-xl" data-id="element-122">📘</span>
                  <h3 className="font-bold text-white text-sm md:text-lg font-serif" data-id="element-123">
                    PROFES DE TELAS RESUELTO
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-white/50" data-id="element-124">
                  6 Tomos + 6 Bonos
                </p>
              </div>

              <div className="text-right flex-shrink-0" data-id="element-125">
                <div className="text-xs md:text-sm text-white/40 line-through mb-0.5" data-id="element-126">
                  $34.990
                </div>
                <div className="text-xl md:text-3xl font-bold text-white" data-id="element-127">
                  $19.990
                </div>
              </div>
            </div>
          </div>

          {/* Elite Plan */}
          <div onClick={() => setSelectedPlan('elite')} className={`relative rounded-2xl p-4 md:p-6 cursor-pointer transition-all duration-300 border-2 mt-2 ${selectedPlan === 'elite' ? 'border-accent bg-primary shadow-lg' : 'border-white/10 bg-primary/80 hover:bg-primary'}`} data-id="element-128">
            {/* Badges */}
            <div className="absolute -top-3 left-4 md:left-6 flex gap-2 z-10" data-id="element-129">
              <span className="bg-yellow-400 text-yellow-900 text-[10px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full flex items-center gap-1 shadow-sm" data-id="element-130">
                🔥 MÁS ELEGIDO
              </span>
              <span className="bg-white/20 text-white text-[10px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full shadow-sm backdrop-blur-sm" data-id="element-131">
                AHORRÁS $16.000
              </span>
            </div>

            <div className="flex items-start md:items-center gap-3 md:gap-4 pt-2 md:pt-0" data-id="element-132">
              <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center mt-1 md:mt-0 transition-colors ${selectedPlan === 'elite' ? 'border-accent' : 'border-white/30'}`} data-id="element-133">
                {selectedPlan === 'elite' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 bg-accent rounded-full" data-id="element-134" />}
              </div>

              <div className="flex-grow" data-id="element-135">
                <div className="flex items-center gap-2 mb-1" data-id="element-136">
                  <span className="text-lg md:text-xl" data-id="element-137">🏆</span>
                  <h3 className="font-bold text-white text-sm md:text-lg font-serif leading-tight" data-id="element-138">
                    PROFES DE TELAS RESUELTO + PACK ÉLITE™
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-white/50 leading-relaxed" data-id="element-139">
                  6 Tomos + 6 Bonos + Kit Emprendedora Fit + Programa Anual 12
                  Meses
                </p>
              </div>

              <div className="text-right flex-shrink-0" data-id="element-140">
                <div className="text-xs md:text-sm text-white/40 line-through mb-0.5" data-id="element-141">
                  $43.990
                </div>
                <div className="text-xl md:text-3xl font-bold text-accent" data-id="element-142">
                  $27.990
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <motion.a href={checkoutUrls[selectedPlan]} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full bg-accent hover:bg-accent-hover text-white font-bold py-4 md:py-5 px-6 rounded-xl text-center text-sm md:text-lg shadow-lg flex justify-center items-center gap-2 transition-colors" data-id="element-143">
          {selectedPlan === 'standard' ? '→ SÍ, QUIERO EL PROFES DE TELAS RESUELTO' : '→ SÍ, QUIERO EL PACK COMPLETO CON TODO'}
        </motion.a>

        {/* Testimonial Quote */}
        <p className="text-center text-xs md:text-sm text-white/50 italic mt-6 mb-8 px-4" data-id="element-144">
          "La más elegida por instructoras que quieren enseñar con seguridad
          total y verse como las profesionales que realmente son"
        </p>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm text-white/50 font-medium" data-id="element-145">
          <div className="flex items-center gap-1.5" data-id="element-146">
            <Lock size={16} className="text-white/40" data-id="element-147" />
            <span data-id="element-148">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-149">
            <Zap size={16} className="text-yellow-400" data-id="element-150" />
            <span data-id="element-151">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-152">
            <ShieldCheck size={16} className="text-accent" data-id="element-153" />
            <span data-id="element-154">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-155">
            <CreditCard size={16} className="text-white/40" data-id="element-156" />
            <span data-id="element-157">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
};